import { render, staticRenderFns } from "./signin.vue?vue&type=template&id=bcc0c76a&scoped=true&"
import script from "./signin.vue?vue&type=script&lang=js&"
export * from "./signin.vue?vue&type=script&lang=js&"
import style0 from "../../../css/ui-primitives.css?vue&type=style&index=0&lang=css&"
import style1 from "./signin.vue?vue&type=style&index=1&id=bcc0c76a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc0c76a",
  null
  
)

export default component.exports